import { render, staticRenderFns } from "./club.vue?vue&type=template&id=56331c92&scoped=true&"
import script from "./club.vue?vue&type=script&lang=js&"
export * from "./club.vue?vue&type=script&lang=js&"
import style0 from "./club.vue?vue&type=style&index=0&id=56331c92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56331c92",
  null
  
)

export default component.exports